<template>
  <div class="session_wrapp">
    <div class="sessions_wrapper">
      <div v-if="!this.sessionItems.length">No session added</div>
      <div
        v-else
        class="session_element"
        v-for="session in this.sessionItems"
        :key="session.node.seqno"
      >
        <SessionElement :sessionElement="session"></SessionElement>
      </div>
    </div>
    <EventsList :sessionItems="this.sessionItems"></EventsList>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import SessionElement from "../../libs/meetSession/meetSessionElement.vue";
import EventsList from "../../libs/meetSession/eventsList.vue";
export default {
  components: { SessionElement, EventsList },
  props: {
    meetId: String
  },
  data() {
    return {
      loading: true,
      formValid: true,
      dialogSessionEvent: false
    };
  },
  computed: {
    ...mapGetters(["meetSessions", "allSessionEvent"]),
    sessionItems() {
      return this.meetSessions.edges.filter(item => {
        return item.node.meetId == this.meetId;
      });
    }
  },
  methods: {
    closeSessionEvent() {
      this.dialogSessionEvent = false;
    },
    addEvent(seqno) {
      this.dialogSessionEvent = true;
    }
  },
  async created() {
    await this.$store
      .dispatch("allMeetEvent")
      .then(() => {})
      .catch(error => {
        console.error(error);
      });
  }
};
</script>

<style>
.sessions_wrapper {
  border: 1px solid rgb(119, 116, 116);
  width: 100%;
}
.session_wrapp {
  display: flex;
  flex-direction: row;
}
.session_element {
  padding: 10px;
}
</style>
